import { render, staticRenderFns } from "./p24_payment_methods.vue?vue&type=template&id=440fd14b&scoped=true&"
import script from "./p24_payment_methods.vue?vue&type=script&lang=js&"
export * from "./p24_payment_methods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440fd14b",
  null
  
)

export default component.exports